export const Forbidden = ({ message }: { message?: string }) => {
  return (
    <div className='card-body py-3'>
      <div className='alert alert-danger'>{message ? message : 'У вас нет доступа к этой странице'}</div>
    </div>
  )
}
